(function () {
    "use strict";

    var _AnalyticsService;

    Directives.PeopleCardDirective = function PeopleCardDirective() {

        // @ngInject
        function PeopleCardControllerFunc($scope, $injector, $document, $state, $translate, UiPersistenceService,
                                           AppStates, UsersManager, ContactsManager, AnalyticsService, UserService, AbTestService,
                                           PopupMessageService, UIUtils, ModalService, ConversationService, NetworkManager, Enums, EventService) {

            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'PeopleCardController';
            var self = this;

            this.UiPersistenceService = UiPersistenceService;

            this.inviteText = 'DASHBOARD.CONTACTS.INVITATION._INVITE_';
            this.chatText = 'DASHBOARD.CONTACTS.CONVERSATION._START_CHAT_';
            this.wasInvitationSent = false;

            _AnalyticsService = AnalyticsService;
            this.AnalyticsService = AnalyticsService;
            this.ContactsManager = ContactsManager;
            this.AppStates = AppStates;
            this.$state = $state;
            this.ConversationService = ConversationService;
            this.UserService = UserService;
            this.UsersManager = UsersManager;
            this.PopupMessageService = PopupMessageService;
            this.UIUtils = UIUtils;
            this.AnalyticsService = AnalyticsService;
            this.ModalService = ModalService;
            this.currUser = UsersManager.getCurrUser();
            this.isCurrUserVendor = this.currUser.isVendor();
            this.isVendor = this.contact.user.isVendor();
            this.NetworkManager = NetworkManager;
            this.Enums = Enums;
            this.AbTestService = AbTestService;
            this.EventService = EventService;

            var openFirstClient = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.openFirstClient, {show: true}).show;
            var shouldShowClientAccessibility = this.UserService.shouldShowClientAccessibilityTopNav(this.currUser);
            if (shouldShowClientAccessibility && openFirstClient) {
                this.showMore = true;
                this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.openFirstClient, {show: false});
            }

            // WIP this just returns true for now
            this.showVendorLinks = this.UsersManager.showVendorLinks(this.contact.user);

            $scope.$watch('peopleCardVm.contact.workspaces_count', function (val) {
                var plural = self.contact.workspaces_count > 1 ? 's' : '';
                $translate('DASHBOARD.CONTACTS.LABELS._CONNECTED_IN_', {
                    workspaces_count: self.contact.workspaces_count,
                    plural: plural
                }).then(function (text) {
                    self.connectedText = text;
                });
            }).bind(this);


            this.isDeletingCard = false;

            this.contact.rating = this.contact.rating || 0;

            $document.ready(function runFoundation() {
                $document.foundation();
            });

            this.allowEdit = function allowEdit() {
                return this.contact.user.editable;
            };
            this.allowDelete = function allowDelete() {
                return this.contact.deletable;
            };

            this.clickEdit = function clickEdit() {
                this.UserService.editContact(this.contact.user);
            };

            this.showConnectionsDropdown = false;
            this.toggleConnectionsDropdown = function toggleConnectionsDropdown() {
                if (this.showConnectionsDropdown === false) {
                    this.showConnectionsDropdown = true;
                }
            };

            this.inviteContact = function inviteContact() {
                if (!this.contact.invited) {

                    var analyticsArgs = {
                        contact_email: this.contact.user.email,
                        contact_id: this.contact._id
                    };

                    this.inviteText = 'DASHBOARD.CONTACTS.INVITATION._SENDING_';
                    ContactsManager.inviteContact(this.contact).then(function success() {
                        _AnalyticsService.track(self, _AnalyticsService.analytics_events.invite_contact, analyticsArgs);

                        self.inviteText = 'DASHBOARD.CONTACTS.INVITATION._SENT_';
                        self.contact.invited = true;
                        self.wasInvitationSent = true;

                    }, function error() {

                        _AnalyticsService.track(self, _AnalyticsService.analytics_events.invite_contact_unsuccessful, analyticsArgs);

                        self.PopupMessageService.showErrorAlert('DASHBOARD.CONTACTS.INVITATION._ERROR_');

                        // change button to invite
                        self.inviteText = 'DASHBOARD.CONTACTS.INVITATION._INVITE_';
                    });
                }
            };

            this.chatWithContact = function chatWithContact(){

                var usersIds = [];
                usersIds.push(this.currUser._id)
                usersIds.push(this.contact.user._id)
                this.ConversationService.startConversation(usersIds);
            };


            this.goToWorkspace = function goToWorkspace(workspace) {
                this.$state.go(this.AppStates.root_core_navigation_event_workspace_feed, {
                    workspace_id: workspace._id,
                    event_id: workspace.event._id
                });
            }.bind(this);

            $scope.filterSelectedTags = function filterSelectedTags(tag) {
                return tag.selected;
            };

            this.addOrRemoveTag = function addOrRemoveTag(tag) {
                var self = this;

                if (tag.fixed) {
                    return;
                }

                tag.selected = !tag.selected;

                var analyticsArgs = {
                    contact_email: this.contact.user.email,
                    contact_id: this.contact._id,
                    tag_changed: tag.name,
                    tag_selected: tag.selected
                };

                var userTags = [];
                for (var tagIndex = 0; tagIndex < self.contact.user_tags.length; tagIndex++) {
                    if (self.contact.user_tags[tagIndex].selected) {
                        userTags.push(self.contact.user_tags[tagIndex].name);
                    }
                }

                this.ContactsManager.updateContactTags(self.contact, userTags).then(function success() {
                    _AnalyticsService.track(self, _AnalyticsService.analytics_events.update_contact_tags, analyticsArgs);

                }, function error() {
                    _AnalyticsService.track(self, _AnalyticsService.analytics_events.update_contact_tags_unsuccessful, analyticsArgs);

                    // reverse selection
                    tag.selected = !tag.selected;
                });


            };

            // this.updatePreferred = function updatePreferred(is_preferred) {
            //     var self = this;
            //     this.ContactsManager.savePreferredVendorContact(this.contact, is_preferred).then(function () {
            //         self.afterUpdateContact(self.contact);
            //     });
            // 
            // };

            this.deleteContact = function deleteContact() {
                this.PopupMessageService.showConfirmPromise(this.PopupMessageService.severityTypes.info, {
                    translationId: 'FREQUENT_MESSAGES._CONFIRM_DELETE_',
                    interpolateParams: { type: 'contact' }
                }).then(function ok() {
                    var analyticsArgs = {
                        contact_email: this.contact.user.email,
                        contact_id: this.contact._id
                    };

                    this.isDeletingCard = true;
                    this.ContactsManager.deleteContact(this.contact).then(function success() {
                        this.contact.isDeleted = true;
                        this.afterUpdateContact(this.contact);
                        this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.delete_contact, analyticsArgs);
                        this.isDeletingCard = false;

                    }.bind(this)).catch(function error() {
                        this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.delete_contact_unsuccessful, analyticsArgs);
                        this.isDeletingCard = false;
                    }.bind(this));
                }.bind(this));
            };

            this.analyticsProperties = function analyticsProperties() {

                var props = {};
                if (this.contact) {
                    props.contact_id = this.contact._id;
                    props.contact_system_tags = this.contact.system_tags;
                    props.contact_common_workspaces_count = this.contact.workspaces_count;

                    if (this.contact.user_tags) {
                        var userTags = [];
                        for (var i = 0; i < this.contact.user_tags.length; i++) {
                            if (this.contact.user_tags[i].selected) {
                                userTags.push(this.contact.user_tags[i].name);
                            }

                        }
                        props.contact_user_tags = userTags;
                    }

                    if (this.contact.user) {
                        props.contact_user_id = this.contact.user._id;
                        props.contact_email = this.contact.user.email;
                        props.contact_name = this.contact.user.full_name;
                        props.contact_system_user_type = this.contact.user.system_user_type;

                    }

                }
                return props;
            };

            if (this.contact &&
                this.contact.user &&
                this.contact.user.network &&
                this.contact.user.network.connection_data &&
                this.contact.user.network.connection_data.connection_status &&
                this.contact.user.network.connection_data.connection_status.length) {
                this.connectionStatus = this.contact.user.network.connection_data.connection_status;
            } else {
                this.connectionStatus = '';
            }
        }

        var PeopleCardController = Class(Controllers.BaseController, {
            constructor: PeopleCardControllerFunc,

            hasMoreData: function () {
                return this.contact.user.email || this.contact.user.phone_number || this.contact.user.address ||
                    (this.contact.user.company && this.contact.user.company.website_url);
            },

            setRating: function setRating(rating) {
                var analyticsArgs = this.analyticsProperties();
                analyticsArgs.new_rating = rating;
                analyticsArgs.previous_rating= this.contact.rating;
                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.update_contact_rating, analyticsArgs);
                if (rating === this.contact.rating) {
                    return; //no need to update server
                }
                this.ContactsManager.updateContactRating(this.contact, rating).then(
                    function success() {
                        this.afterUpdateContact(this.contact);
                    }.bind(this)
                );
            },

            showMoreClicked: function showMoreClicked() {
                this.showMore = !this.showMore;
                this.ContactsManager.getWorkspaceConnectionsForContact(this.contact);
            },
            
            togglePreferred: function togglePreferred(event) {
               event.stopPropagation();
               event.preventDefault();

            //    if(!this.contact) {
            //        this.ContactsManager.createPreferredContact(this.user, 'community', true)
            //             .then(function success(response) {
            //                 this.contact = response.data;
            //             }.bind(this));
            //    } else {
                   this.ContactsManager.updatePreferredVendorContact(this.contact, !this.contact.is_preferred)
                        .then(function success(resp){
                            this.contact.is_preferred = resp.data.is_preferred;
                        }.bind(this));
                // }
            },

            isPreferred: function isPreferred() {
                return this.contact.is_preferred;
            },

            connect: function connect(event) {
                event.stopPropagation();
                event.preventDefault();

                this.NetworkManager.createConnectionRequest(this.contact.user_id);

                this.connectionStatus = 'requested';

                console.error('FIX CONNECT');
            },

            addProject:function addProject(userId) {
                var config = {userId: userId };
                this.EventService.createEventCommand(config);
            }

        });

        return {
            scope: {
                contact: '=contact',
                afterUpdateContact: '&afterUpdateContact',
                showRatings: '=showRatings',
                showInitialsForMissingProfileImage: '=',
                showActionsForCreatives: '='
            },
            templateUrl: 'angular/app/modules/core/features/people/people_card/people_card_directive_template.html',
            controller: PeopleCardController,
            controllerAs: 'peopleCardVm',
            bindToController: true
        };
    };
}());


